import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import WaterPumpDetail from '../../components/ac_central/WaterPumpDetail';
import { defaultRejectHandler } from '../../utils/utility';
import { createWaterPump } from '../../redux/ac_central/water_pump_actions';

class WaterPumpCreateModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.wpDetail = undefined;
  }

  onSaveHandler() {
    const newWP = this.wpDetail.getWrappedInstance().getWrappedInstance().getWPData();
    this.props.createWaterPump(newWP);
  }

  render() {
    const { isCreating, errorMessage, wpDetail, t, getWaterPump, createWaterPump, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('create water pump')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <WaterPumpDetail
            wp={wpDetail}
            ref={ref => (this.wpDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="air-conditioning-water-pump-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {isCreating ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.ac.waterPump.errorMessage,
  isCreating: state.ac.waterPump.isCreating,
  wpDetail: props.wp && state.ac.waterPump.objects[props.wp.id],
});

const mapDispatchToProps = dispatch => ({
  createWaterPump: wp => defaultRejectHandler(dispatch(createWaterPump(wp.name, wp.type, wp.power_required, wp.description, wp.image))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(WaterPumpCreateModal),
);



// WEBPACK FOOTER //
// ./src/modal/ac_central/WaterPumpCreateModal.js